import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Download, Bell, CreditCard, QrCode } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Members() {
  return <div className="w-full bg-club-canvas" data-id="element-1142">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-1143">
        <div className="absolute inset-0 z-0 bg-club-green" data-id="element-1144">
          <div className="absolute inset-0 opacity-10" data-id="element-1145">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-1146">
              <defs data-id="element-1147">
                <pattern id="pattern-members" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-1148">
                  <path d="M0 40L40 0H20L0 20M40 40V20L20 40" fill="currentColor" fillOpacity="0.5" data-id="element-1149" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#pattern-members)" data-id="element-1150" />
            </svg>
          </div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-1151">
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1152">
            Member Services
          </motion.h1>
          <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-1153">
            Access your exclusive member information and resources.
          </motion.p>
        </div>
      </section>

      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-1154">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-1155">
          {/* Main Content Area */}
          <div className="lg:col-span-2 space-y-12" data-id="element-1156">
            {/* Notices */}
            <div data-id="element-1157">
              <div className="flex items-center justify-between mb-6" data-id="element-1158">
                <div className="flex items-center gap-3" data-id="element-1159">
                  <Bell className="text-club-gold" size={24} data-id="element-1160" />
                  <h2 className="text-3xl" data-id="element-1161">Recent Notices</h2>
                </div>
                <Link to="/members/information" className="text-sm text-club-green font-medium hover:text-club-gold transition-colors" data-id="element-1162">
                  View All
                </Link>
              </div>
              <div className="space-y-4" data-id="element-1163">
                {[{
                date: 'Oct 10, 2026',
                title: 'Annual General Meeting Announcement',
                desc: 'The AGM will be held on Nov 20th. Please review the agenda.'
              }, {
                date: 'Oct 05, 2026',
                title: 'Update on Pool Maintenance',
                desc: 'The indoor pool will be closed for routine maintenance from Oct 12-14.'
              }, {
                date: 'Sep 28, 2026',
                title: 'New Reciprocal Club Added',
                desc: 'We are pleased to announce a new reciprocal arrangement with The Royal Club, Sydney.'
              }].map((notice, i) => <div key={i} className="bg-white p-6 border border-club-border rounded-sm" data-id="element-1164">
                    <span className="text-sm text-club-gold font-medium block mb-2" data-id="element-1165">
                      {notice.date}
                    </span>
                    <h4 className="text-xl mb-2" data-id="element-1166">{notice.title}</h4>
                    <p className="text-club-ink/70 text-sm" data-id="element-1167">{notice.desc}</p>
                  </div>)}
              </div>
            </div>

            {/* Downloads */}
            <div data-id="element-1168">
              <div className="flex items-center justify-between mb-6" data-id="element-1169">
                <div className="flex items-center gap-3" data-id="element-1170">
                  <FileText className="text-club-gold" size={24} data-id="element-1171" />
                  <h2 className="text-3xl" data-id="element-1172">Documents & Forms</h2>
                </div>
                <Link to="/members/information" className="text-sm text-club-green font-medium hover:text-club-gold transition-colors" data-id="element-1173">
                  View All
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1174">
                {['Club Rules & Bye-Laws 2026', 'Membership Proposal Form', 'Direct Debit Mandate', 'Private Event Booking Form'].map((doc, i) => <div key={i} className="flex items-center justify-between bg-white p-4 border border-club-border rounded-sm hover:border-club-gold transition-colors cursor-pointer group" data-id="element-1175">
                    <span className="text-sm font-medium text-club-ink group-hover:text-club-green" data-id="element-1176">
                      {doc}
                    </span>
                    <Download size={16} className="text-club-ink/40 group-hover:text-club-gold" data-id="element-1177" />
                  </div>)}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-8" data-id="element-1178">
            {/* Member Portal Entry */}
            <div className="bg-club-green text-white p-6 rounded-sm" data-id="element-1179">
              <h3 className="text-xl font-serif mb-2 text-club-gold" data-id="element-1180">
                Member Portal
              </h3>
              <p className="text-sm text-club-canvas/80 mb-5" data-id="element-1181">
                View your balance, transactions, and digital membership card.
              </p>
              <div className="space-y-3" data-id="element-1182">
                <Link to="/members/dashboard" className="w-full btn-gold py-3 flex justify-center items-center gap-2" data-id="element-1183">
                  <CreditCard size={18} data-id="element-1184" /> Go to Dashboard
                </Link>
                <Link to="/members/card" className="w-full btn-secondary text-white border-white hover:bg-white/10 py-3 flex justify-center items-center gap-2" data-id="element-1185">
                  <QrCode size={18} data-id="element-1186" /> Digital Member Card
                </Link>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-club-canvasAlt p-6 border border-club-border rounded-sm" data-id="element-1187">
              <h3 className="text-xl mb-6 border-b border-club-border pb-4" data-id="element-1188">
                Quick Actions
              </h3>
              <div className="space-y-3" data-id="element-1189">
                <Link to="/members/dashboard" className="w-full btn-primary py-3 flex justify-center items-center gap-2" data-id="element-1190">
                  <CreditCard size={18} data-id="element-1191" /> Pay Subscriptions
                </Link>
                <Link to="/members/information" className="w-full btn-secondary py-3 block text-center" data-id="element-1192">
                  Update Profile
                </Link>
                <Link to="/members/dashboard" className="w-full btn-secondary py-3 block text-center" data-id="element-1193">
                  View Statements
                </Link>
              </div>
            </div>

            {/* Support */}
            <div className="bg-white p-6 border border-club-border rounded-sm" data-id="element-1194">
              <h3 className="text-xl mb-4" data-id="element-1195">Member Support</h3>
              <p className="text-sm text-club-ink/70 mb-4" data-id="element-1196">
                For assistance with your account or general enquiries, please
                contact the membership office.
              </p>
              <p className="text-sm font-medium text-club-green mb-1" data-id="element-1197">
                membership@andhraassociation.com
              </p>
              <p className="text-sm font-medium text-club-green" data-id="element-1198">
                +91 44 2815 3052
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}